var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasError)?_c('img',{attrs:{"src":_vm.src,"alt":""},on:{"error":_vm.handleImageLoadError}}):_c('div',{staticClass:"img-placeholder icon-upload-image gray-bg"})}
var staticRenderFns = []

export { render, staticRenderFns }